export const dictionary = {
  seo: {
    defaultDescription: 'משרד עורכי דין עומר זילבר — מקרקעין, משפט מסחרי, מעמד אישי ועסקאות מורכבות',
    homeDescription: 'משרד עורכי דין עומר זילבר — ליווי מקצועי בעסקאות מקרקעין, משפט מסחרי, צוואות וייפויי כוח',
    aboutDescription: 'הכירו את צוות משרד עורכי דין עומר זילבר — מומחים במקרקעין, משפט מסחרי ודיני מעמד אישי',
    articlesDescription: 'מאמרים מקצועיים בתחומי מקרקעין, צוואות, חוזים ועסקאות — משרד עורכי דין עומר זילבר',
    contactDescription: 'צרו קשר עם משרד עורכי דין עומר זילבר לייעוץ משפטי בתחומי מקרקעין, משפט מסחרי ומעמד אישי',
  },
  general: {
    firmName: 'משרד עורכי דין עומר זילבר',
    phone: '073-7322001',
    email: 'office@omerzilber.co.il',
    address: 'יסמין 287, צור הדסה',
    whatsapp: '972527734857',
    waze: 'https://waze.com/ul/hsv8uqwp2y',
    leaveDetails: 'השאירו פרטים',
    readMore: 'קרא עוד',
    navLinks: {
      home: 'בית',
      articles: 'מאמרים',
      about: 'אודות',
      contact: 'צור קשר',
    },
    footer: {
      copyright: '© כל הזכויות שמורות למשרד עורכי דין עומר זילבר',
      hours: 'א׳-ה׳ 09:00-18:00',
    },
    floatingCta: {
      whatsapp: 'WhatsApp',
      leaveDetails: 'השאירו פרטים',
    },
    cookieConsent: {
      message: 'אתר זה משתמש ב- Cookies לשיפור חוויית הגלישה',
      accept: 'אישור',
    },
    aria: {
      skipToContent: 'דלג לתוכן',
      menu: 'תפריט',
      closeMenu: 'סגור תפריט',
      slide: 'שקופית',
      stopCarousel: 'עצור',
      playCarousel: 'הפעל',
      previousSlide: 'הקודם',
      nextSlide: 'הבא',
      mainNav: 'ניווט ראשי',
      formSuccess: 'הטופס נשלח בהצלחה',
      formError: 'שגיאה בשליחת הטופס',
      retrySubmit: 'נסה שוב לשלוח את הטופס',
      heroCarousel: 'קרוסלת באנרים ראשית',
      carousel: 'קרוסלה',
      slideAnnouncement: (current: number, total: number) => `שקופית ${current} מתוך ${total}`,
    },
  },
  homepage: {
    slides: [
      {
        title: 'עסקאות נדל״ן - קנייה ומכירה',
        subtitle:
          'טיפול משפטי מקיף ברכישת ומכירת דירות ונכסים. כולל בדיקות משפטיות ותכנוניות, חוזי מכר וניהול התהליך עד השלמת העסקה.',
        cta: 'לייעוץ בעסקת נדל״ן',
        ctaLink: '/contact',
        media: { type: 'image' as const, src: '/images/hero/hero-1.webp' },
      },
      {
        title: 'נכסים והון משפחתי והעברה בין-דורית',
        subtitle: 'ליווי אישי, רגיש ומקצועי בניהול נכסים והסכמים בתוך המשפחה. עריכת צוואות והכנת ייפוי כוח מתמשך.',
        cta: 'לתכנון משפחתי נכון',
        ctaLink: '/contact',
        media: { type: 'image' as const, src: '/images/hero/hero-2.webp' },
      },
      {
        title: 'משפט מסחרי ועסקאות מורכבות',
        subtitle: 'פתרונות משפטיים יצירתיים לעסקים בכל הגדלים, ליווי בעסקאות מורכבות וניהול הסכמים מסחריים.',
        cta: 'לליווי משפטי עסקי',
        ctaLink: '/contact',
        media: { type: 'image' as const, src: '/images/hero/hero-3.webp' },
      },
    ],
  },
  about: {
    pageTitle: 'אודות המשרד',
    firm: {
      title: 'אודות משרד עורכי דין עומר זילבר',
      vision:
        'משרד עורכי דין עומר זילבר מתמחה בליווי עסקאות מקרקעין, משפט מסחרי, דיני מעמד אישי ועסקאות מורכבות. המשרד מציע מענה משפטי מקיף ומקצועי ללקוחות פרטיים ועסקיים כאחד.',
      values:
        'אנו מאמינים ביחס אישי, מקצועיות ללא פשרות ושקיפות מלאה מול הלקוח. כל תיק מקבל את מלוא תשומת הלב והמומחיות הנדרשת.',
      approachStart: 'הגישה שלנו משלבת ידע משפטי מעמיק עם חשיבה עסקית ופרקטית ',
      approachBold: 'ובדגש על הבנת הצרכים והפוזיציות של הלקוחות.',
      approachEnd: '\n אנו מלווים את לקוחותינו מהשלב הראשון ועד להשלמת העסקה, תוך מתן מענה מהיר ויעיל.',
    },
    team: {
      title: 'הצוות שלנו',
      drawer: {
        close: 'סגור',
        backToTeam: 'חזרה לצוות',
        specializations: 'תחומי התמחות',
        about: 'אודות',
        education: 'השכלה',
        certifications: 'הסמכה',
      },
      members: [
        {
          name: 'עומר זילבר',
          title: 'עורך דין ורואה חשבון',
          email: 'Omer@omerzilber.co.il',
          photo: '/images/team/omer-zilber.webp',
          specializations: ['עסקאות מקרקעין', 'חוזים מסחריים', 'ניהול הון משפחתי והעברה בין-דורית', 'מיסוי מקרקעין', 'נדל"ן ביהודה ושומרון'],
          about:
            'עו"ד ורו"ח עומר זילבר משלב מומחיות בעסקאות מקרקעין ומשפט מסחרי עם רקע ייחודי בראיית חשבון. בעבר עבד בפירמת עורכי הדין ש. פרידמן אברמזון ושות\' וכיועץ משפטי בחברה יזמית. עומר מרצה למיסוי מקרקעין ומיסוי תאגידים בחוג לכלכלה וחשבונאות במרכז האקדמי הרב תחומי בירושלים.',
          education: ['LL.B משפטים וחשבונאות — האוניברסיטה העברית', 'LL.M משפט מסחרי — האוניברסיטה העברית'],
          certifications: ['עורך דין, 2019', 'רואה חשבון, 2018'],
        },
        {
          name: 'רון להב-היימן',
          title: 'עורכת דין',
          email: 'Ron@omerzilber.co.il',
          photo: '/images/team/ron-lahav.webp',
          specializations: ['עסקאות מקרקעין', 'ייפוי כוח מתמשך, צוואות וירושות', 'הסכמי ממון', 'ניהול הון משפחתי והעברה בין-דורית'],
          about:
            'עו"ד רון להב היימן מתמחה בעסקאות מקרקעין ובדיני המעמד האישי - צוואות, ייפוי כוח מתמשך, הסכמי ממון ואפוטרופסות. מלווה ברגישות עסקאות יורשים ונכסים משפחתיים.',
          education: ['LL.B משפטים - המכללה האקדמית ספיר'],
          certifications: ['עורכת דין, 2019'],
        },
        {
          name: 'מתן לנקרי',
          title: 'עורך דין',
          email: 'Matan@omerzilber.co.il',
          photo: '/images/team/matan-lankri.webp',
          specializations: ['עסקאות מקרקעין', 'חוזים מסחריים', 'מכרזים'],
          about:
            'עו"ד מתן לנקרי מתמחה בעסקאות מקרקעין ובהסכמים מסחריים מגוונים. ניסיון עם גופים ציבוריים ותאגידים - רשות מקרקעי ישראל, רכבת ישראל, בזק. כמו כן, מתן מתמחה בדיני מעמד אישי ומלווה לקוחות פרטיים ו-family office בתכנון ההון המשפחתי',
          education: ['LL.B משפטים - האוניברסיטה העברית'],
          certifications: ['עורך דין, 2021'],
        },
        {
          name: "אור יורוביץ'",
          title: 'עורך דין ושמאי מקרקעין',
          email: 'Or@omerzilber.co.il',
          photo: '/images/team/or-yurovitz.webp',
          specializations: ['עסקאות מקרקעין', 'חוזים מסחריים', 'נדל"ן ביהודה ושומרון'],
          about:
            'עו"ד ושמאי מקרקעין אור יורוביץ\' מתמחה בעסקאות נדל"ן מורכבות. משלב מומחיות משפטית עם ידע כלכלי ותכנוני רחב. בעבר עבד בפירמת עורכי הדין ארנון תדמור-לוי ושות\' ובחברת ירון ספקטור שמאות מקרקעין.',
          education: ['LL.B משפטים - אוניברסיטת בר אילן', 'MBA מנהל עסקים - אוניברסיטת בר-אילן'],
          certifications: [' עורך דין, 2022', 'שמאי מקרקעין, 2024'],
        },
        {
          name: 'מיכל',
          title: 'מנהלת משרד',
          email: 'Office@omerzilber.co.il',
          photo: '/images/team/michal.webp',
          specializations: [],
          about: 'מיכל אחראית על הניהול האדמיניסטרטיבי והתפעולי של המשרד, לרבות התנהלות שוטפת מול לקוחות, רשויות וגורמים מקצועיים. מטפלת בתהליכי עבודה מול מועצות ורשויות שונות, בתפעול מערך הגבייה ובניהול ממשקי עבודה מול גורמים ממשלתיים ועסקיים.',
          education: ['B.A מנהל עסקים ומשאבי אנוש - המכללה האקדמית רמת גן'],
        },
      ],
    },
  },
  articles: {
    pageTitle: 'מאמרים',
    relatedArticlesTitle: 'מאמרים נוספים',
    items: [
      {
        slug: 'second-hand-apartment-guide-part-2',
        title: 'מה לבדוק לפני חתימה על חוזה רכישת דירה יד שנייה',
        date: '01-03-2026',
        author: 'עו"ד מתן לנקרי',
        readTime: '8 דקות קריאה',
        excerpt:
          'רכישת דירה יד שנייה היא אחת העסקאות המשמעותיות ביותר בחיים. לפני שאתם חותמים על חוזה המכר, חשוב לדעת אילו בדיקות חובה לבצע כדי להבטיח עסקה בטוחה וחלקה.',
        heroImage: '/images/articles/article-1.webp',
        body: [
          {
            type: 'paragraph' as const,
            content:
              'רכישת דירה יד שנייה היא אחת העסקאות המשמעותיות ביותר בחיים — ולעיתים גם אחת המורכבות שבהן. לצד ההתרגשות והשאיפה לבית חדש, קיימים סיכונים משפטיים להם צריך לתת מענה וסיכונים תכנוניים שעלולים להתגלות רק לאחר החתימה. לפני שאתם חותמים על חוזה המכר, חשוב לדעת אילו בדיקות חובה לבצע כדי להבטיח שהעסקה תעבור בצורה בטוחה, חלקה וללא הפתעות מיותרות ויקרות.',
          },
          {
            type: 'heading' as const,
            content: 'בדיקת הזכויות בדירה — למי באמת הנכס שייך?',
          },
          {
            type: 'paragraph' as const,
            content:
              'השלב הראשון הוא לוודא שהמוכר הוא הבעלים החוקי של הדירה. יש להוציא נסח טאבו מעודכן או אישור זכויות מרשות מקרקעי ישראל או חברה משכנת, ולבדוק:',
          },
          {
            type: 'list' as const,
            content: [
              'שהמוכר רשום כבעלים של מלוא הזכויות. אם לא, נדרשת הסכמת כל הבעלים למכירת הנכס',
              'שאין עיקולים, הערות אזהרה, צווי מניעה או משכנתאות. אם יש, צריך להתייחס לכך בהסכם',
              'שהפרטים הרשומים (גוש, חלקה, תת-חלקה וכתובת) תואמים למציאות',
            ],
          },
          {
            type: 'paragraph' as const,
            content:
              'עו"ד המתמחה במקרקעין יוודא שהזכויות נקיות מהגבלות כלשהן ושהדירה ניתנת להעברה ורישום תקין על שם הרוכש.',
          },
          {
            type: 'heading' as const,
            content: 'בדיקת מצב תכנוני והיתרי בנייה',
          },
          {
            type: 'paragraph' as const,
            content: 'לפני החתימה, חשוב לבדוק בעירייה או בוועדה המקומית האם קיימות:',
          },
          {
            type: 'list' as const,
            content: [
              'חריגות בנייה, הרחבות או סגירות שבוצעו ללא היתר',
              'צווי הריסה או הליכים משפטיים פתוחים',
              'תוכניות בנייה או שינויי תב"ע העלולים להשפיע על הנכס',
            ],
          },
          {
            type: 'paragraph' as const,
            content:
              'חריגות בנייה עלולות למנוע קבלת משכנתא או את רישום הזכויות בטאבו. לכן, חובה לבצע בדיקה תכנונית מקדימה.',
          },
          {
            type: 'heading' as const,
            content: 'בדיקת מצב פיזי והנדסי של הדירה',
          },
          {
            type: 'paragraph' as const,
            content: 'המלצה חשובה: להזמין בדק בית או שמאי מוסמך לפני החתימה. הבדיקה תסייע לגלות:',
          },
          {
            type: 'list' as const,
            content: [
              'ליקויי בנייה, רטיבות, סדקים או בעיות חשמל ואינסטלציה',
              'אי התאמות בין תוכניות הדירה למצב בפועל',
              'חריגות או תוספות שאינן מאושרות',
            ],
          },
          {
            type: 'paragraph' as const,
            content:
              'ממצאי הבדיקה יכולים לשמש כלי במשא ומתן על המחיר או להכניס סעיפים מתאימים לחוזה. במקרים בהם הקונה מתכנן לקחת משכנתא, מומלץ ביותר לעשות בדיקה כזו על מנת לוודא שהבנק יסכים להעמיד את ההלוואה הנדרשת.',
          },
          {
            type: 'heading' as const,
            content: 'מיסוי והוצאות נלוות',
          },
          {
            type: 'paragraph' as const,
            content: 'לפני שמתחייבים לרכישה, יש להבין את התמונה הכספית המלאה:',
          },
          {
            type: 'list' as const,
            content: [
              'חבות במס שבח מצד המוכר',
              'גובה מס הרכישה שיחול על הקונה (בהתאם לסוג הרכישה: דירה ראשונה, נוספת או להשקעה ולהטבות מס ספציפיות כמו לעולים חדשים)',
              'חובות ארנונה, מים, ועד בית ותשלומי חובה נוספים שטרם שולמו',
            ],
          },
          {
            type: 'paragraph' as const,
            content:
              'עורך הדין יוודא שכל החובות הוסדרו לפני העברת הבעלות, ויוכל לעזור להעריך באופן מיטבי את עלות העסקה הכוללת.',
          },
          {
            type: 'heading' as const,
            content: 'משכנתא, שעבודים ואישור עקרוני מהבנק',
          },
          {
            type: 'paragraph' as const,
            content:
              'אם על הדירה קיימת משכנתא רשומה, חובה לוודא שהמוכר יסיר אותה לפני מסירת הנכס או במעמד חתימת העסקה. לצד זאת, גם הקונה חייב לוודא שהוא עצמו יוכל לקבל משכנתא — לפני החתימה.',
          },
          {
            type: 'paragraph' as const,
            content:
              'חשוב לקבל אישור עקרוני מהבנק למשכנתאות עוד בשלב המשא ומתן. האישור מבטיח שהבנק מוכן לממן את העסקה בסכום הדרוש, בהתאם להכנסות ולשווי הנכס, ומונע מצבים בהם הקונה חותם על חוזה אך אינו מצליח לגייס את המימון.',
          },
          {
            type: 'paragraph' as const,
            content: 'במעמד החתימה יש לקבוע מנגנון תשלומים בטוח, למשל:',
          },
          {
            type: 'list' as const,
            content: [
              'התשלומים יעברו דרך חשבונות נאמנות של עורכי הדין המייצגים בעסקה',
              'כספים ישוחררו רק לאחר המצאת אישורים להסרת שעבודים, הגבלות והתחייבויות מהבנק או גורמים אחרים',
            ],
          },
          {
            type: 'heading' as const,
            content: 'זהות הצדדים והצהרותיהם בחוזה',
          },
          {
            type: 'paragraph' as const,
            content: 'בחוזה חשוב לוודא שהנכס מתואר במדויק ושהמוכר מספק התחייבויות מספקות, למשל:',
          },
          {
            type: 'list' as const,
            content: [
              'שאין לצדדים אחרים זכויות בדירה',
              'כי הנכס נקי מכל חוב או התחייבות לצד שלישי',
              'שכל המיסים והחשבונות שולמו במלואם עד מועד המסירה',
              'הצהרות על ליקויים שונים',
            ],
          },
          {
            type: 'paragraph' as const,
            content:
              'עו"ד מנוסה מטעמך יוודא שהחוזה מכסה את כל האפשרויות והסיכונים באמצעות הצהרות מפורטות של המוכר, אשר יאפשרו הגנה משפטית במקרה של הפרת התחייבות.',
          },
          {
            type: 'heading' as const,
            content: 'מועדים, תשלומים ומנגנוני ביטחון',
          },
          {
            type: 'paragraph' as const,
            content:
              'יש לתאם לוח תשלומים ריאלי המתאים למקורות המימון (כולל משכנתא), כמו גם מועד מסירה. עורך הדין שילווה אתכם ידע להעריך את לוחות הזמנים על מנת למנוע סיכון לאיחור בתשלומים, קנסות ולהפרת החוזה. בחוזה יש להגדיר:',
          },
          {
            type: 'list' as const,
            content: [
              'מועדי תשלום ומועד מסירת הדירה',
              'מנגנוני ביטחון כמו החזקה ועיכוב כספים בנאמנות או אפשרות לאיחור קל בלי שהדבר יחשב כהפרה',
              'סנקציות ברורות במקרה של איחור או הפרה',
            ],
          },
          {
            type: 'heading' as const,
            content: 'ליווי משפטי — לא לחתום בלי עורך דין מטעמך',
          },
          {
            type: 'paragraph' as const,
            content:
              'גם אם "המוכר כבר הכין חוזה" או אם נראה לכם שהחוזה בסך הכל נראה בסדר, אסור לחתום על חוזה לרכישת דירה בלי שעורך דין מטעמך עבר עליו לעומק. חוזה מכר דירה הוא מסמך משפטי שיכול להסתיר סיכונים עצומים, מסעיף אחריות לא מספק ועד טעויות בהגדרת הנכס.',
          },
          {
            type: 'heading' as const,
            content: 'לסיכום',
          },
          {
            type: 'paragraph' as const,
            content:
              'קניית דירה זו חוויה מרגשת שעלולה אולי להיות מלחיצה, אבל היא עשויה להיות חוויה חיובית ובטוחה אם ניגשים אליה נכון. בדיקה יסודית של הזכויות, המצב הפיזי, התכנוני והמימוני של הנכס, בשילוב ליווי משפטי מקצועי, תבטיח שתקבלו בדיוק את מה ששילמתם עליו, בלי סיכונים ובלי הפתעות.',
          },
        ],
      },
      {
        slug: 'why-draft-a-will',
        title: 'למה חשוב לערוך צוואה — גם (או דווקא) בגיל צעיר',
        date: '20-02-2026',
        author: 'עו"ד רון להב היימן',
        readTime: '5 דקות קריאה',
        excerpt:
          'רבים נוטים לחשוב שצוואה היא עניין לאנשים מבוגרים מאוד. האמת שונה לחלוטין: דווקא זוגות צעירים, במיוחד כאלה שיש להם ילדים קטינים, זקוקים לצוואה יותר מכולם.',
        heroImage: '/images/articles/article-2.webp',
        body: [
          {
            type: 'paragraph' as const,
            content:
              'רבים נוטים לחשוב שצוואה היא עניין לאנשים מבוגרים מאוד או לכאלה שצברו נכסים רבים. האמת שונה לחלוטין: דווקא זוגות צעירים, במיוחד כאלה שיש להם ילדים קטינים, זקוקים לצוואה יותר מכולם.',
          },
          {
            type: 'heading' as const,
            content: 'מה קורה כשאין צוואה?',
          },
          {
            type: 'paragraph' as const,
            content:
              'כאשר אחד מבני הזוג הולך חלילה לעולמו בלי צוואה, החוק קובע שהירושה מתחלקת בין בן הזוג שנותר בחיים לבין הילדים: חצי לבן הזוג וחצי לילדים. לכאורה זה נשמע הוגן, אבל בפועל נוצרת בעיה משמעותית — כאשר היורשים הם קטינים, לא ניתן לבצע עסקאות ברכוש המשפחתי מבלי לקבל אישור מבית המשפט.',
          },
          {
            type: 'paragraph' as const,
            content:
              'ניקח לדוגמה בית מגורים: בן הזוג שנשאר בחיים מעוניין למכור את הבית ולעבור להתגורר קרוב להוריו כדי לקבל עזרה עם הילדים. אך מכיוון שהילדים יורשים חלק מהבית, כל פעולה מחייבת אישור של בית המשפט. ההליך הזה גוזל זמן, כסף ועצבים, ולעיתים אף יכול להכשיל עסקאות.',
          },
          {
            type: 'paragraph' as const,
            content:
              'והבעיה לא נעצרת בנדל"ן בלבד: גם חשבונות בנק, השקעות, מניות ונכסים אחרים הופכים כפופים לאותם חסמים משפטיים.',
          },
          {
            type: 'heading' as const,
            content: 'צוואה — פתרון פשוט לבעיה מורכבת',
          },
          {
            type: 'paragraph' as const,
            content:
              'באמצעות צוואה אפשר להימנע מכל הסיבוכים האלו. בני הזוג יכולים לקבוע בצורה ברורה שכל נכסיהם יעברו תחילה לבן הזוג שנותר בחיים, ורק לאחר פטירת שניהם — לילדים. כך נשמרת היציבות הכלכלית והמשפחתית, ומונעים מצב שבו בן הזוג שנותר בחיים נאלץ להתמודד עם חסמים משפטיים דווקא בתקופה קשה של אבל.',
          },
          {
            type: 'paragraph' as const,
            content:
              'מעבר לכך, בצוואה ניתן לכלול הוראות נוספות — למשל, מי ישמש אפוטרופוס לילדים במקרה של אסון בו שני ההורים נפטרים. אמנם ההכרעה הסופית היא של בית המשפט על פי טובת הילדים, אך כשיש הוראה ברורה בצוואה — היא מקבלת משקל רב בהחלטה. כך ניתן למנוע מחלוקות וסכסוכים בין משפחות.',
          },
          {
            type: 'heading' as const,
            content: 'לשבור את המיתוס — צוואה אינה "מזל רע"',
          },
          {
            type: 'paragraph' as const,
            content:
              'ישנם אנשים הנמנעים מעריכת צוואה מתוך אמונה שזה "מביא מזל רע". אך כפי שאיש לא חושב שביטוח חיים או ביטוח בריאות מזמין אסון — גם צוואה לא. להפך, מדובר בכלי אחראי וחיוני שמעניק ודאות למשפחה ומונע בעיות משפטיות ברגעים בהם הדבר האחרון שתרצו הוא להתמודד עם ביורוקרטיה ובתי משפט.',
          },
          {
            type: 'heading' as const,
            content: 'לסיכום',
          },
          {
            type: 'paragraph' as const,
            content:
              'צוואה אינה שמורה לזקנים או לעשירים בלבד. היא כלי חיוני לכל זוג, ובמיוחד להורים צעירים. עריכת צוואה היא פעולה פשוטה יחסית שמבטיחה שברגעי משבר לא תעמוד המשפחה בפני מכשולים משפטיים מיותרים.',
          },
        ],
      },
      {
        slug: 'buying-from-contractor-guide',
        title: 'רכישת דירה "על הנייר": מה חובה לבדוק לפני חתימה?',
        date: '10-02-2026',
        author: 'עו"ד ורו"ח עומר זילבר',
        readTime: '7 דקות קריאה',
        excerpt:
          'קניית דירה היא כנראה העסקה הכלכלית המשמעותית ביותר בחייכם. כשמדובר בדירה יד ראשונה מקבלן, ההתרגשות מהריח של "חדש" עלולה לטשטש את הסיכונים המשפטיים והכלכליים הטמונים בעסקה.',
        heroImage: '/images/articles/article-3.webp',
        body: [
          {
            type: 'paragraph' as const,
            content:
              'קניית דירה היא כנראה העסקה הכלכלית המשמעותית ביותר בחייכם. כשמדובר בדירה יד ראשונה מקבלן, ההתרגשות מהריח של "חדש" ומההדמיות המרהיבות עלולה לעיתים לטשטש את הסיכונים המשפטיים והכלכליים הטמונים בעסקה.',
          },
          {
            type: 'paragraph' as const,
            content:
              'כדי שלא תמצאו את עצמכם מול שוקת שבורה, ריכזנו עבורכם את הנקודות הקריטיות שחובה לבדוק לפני שמרטיבים את העט וחותמים על חוזה המכר.',
          },
          {
            type: 'heading' as const,
            content: 'בדיקת "הזהות המשפטית" של הקרקע והקבלן',
          },
          {
            type: 'paragraph' as const,
            content:
              'לפני הכל, חשוב להבין על קרקע של מי נבנה הפרויקט. האם זו קרקע פרטית? קרקע של רשות מקרקעי ישראל (רמ"י)?',
          },
          {
            type: 'list' as const,
            content: [
              'נסח טאבו/אישור זכויות: ודאו כי לקבלן או לחברה היזמית יש זכויות בקרקע וכי אין עליהן הערות אזהרה או עיקולים שעלולים לסכל את הפרויקט',
              'ניסיון וחוסן כלכלי: מומלץ לבדוק את ההיסטוריה של הקבלן. האם הוא רשום בפנקס הקבלנים? האם יש נגדו תביעות משמעותיות בגין ליקויי בנייה או איחורי מסירה?',
            ],
          },
          {
            type: 'heading' as const,
            content: 'הבטחת הכספים — חוק המכר',
          },
          {
            type: 'paragraph' as const,
            content:
              'בדירה יד ראשונה, אתם משלמים על נכס שרובו (או כולו) עדיין לא קיים. לכן, ההגנה החשובה ביותר שלכם היא ערבויות חוק המכר.',
          },
          {
            type: 'paragraph' as const,
            content: 'ודאו כי כל תשלום שתעבירו יובטח באמצעות ערבות בנקאית או פוליסת ביטוח מחברת ביטוח מוכרת.',
          },
          {
            type: 'quote' as const,
            content:
              'טיפ משפטי: לעולם אל תעבירו כספים ישירות לקבלן, אלא רק באמצעות פנקס שוברים לחשבון הליווי הסגור של הפרויקט.',
          },
          {
            type: 'heading' as const,
            content: 'המפרט הטכני והתשריטים',
          },
          {
            type: 'paragraph' as const,
            content: 'הבטחות בעל פה של אנשי המכירות לא מחייבות את הקבלן — רק מה שכתוב בחוזה ובנספחיו קובע.',
          },
          {
            type: 'list' as const,
            content: [
              'המפרט (לפי חוק המכר): בדקו היטב מה אתם מקבלים. סוג הריצוף, מספר נקודות החשמל, סוג המטבח והכלים הסניטריים',
              'תשריט הדירה: ודאו ששטח הדירה, כיווני האוויר, המחסן והחניה המוצמדים תואמים את מה שהובטח לכם',
            ],
          },
          {
            type: 'heading' as const,
            content: 'הצמדה למדד התשומות — המוקש הכלכלי',
          },
          {
            type: 'paragraph' as const,
            content:
              'מחיר הדירה בחוזה הוא לרוב לא המחיר הסופי שתשלמו. יתרת התשלומים לקבלן מוצמדת בדרך כלל למדד תשומות הבנייה.',
          },
          {
            type: 'list' as const,
            content: [
              'חשוב לבצע סימולציה של עליית המדד כדי להבין מה תהיה העלות הריאלית של הדירה ביום המסירה',
              'במקרים מסוימים, ניתן לנהל מו"מ על הקפאת המדד או הגבלתו',
            ],
          },
          {
            type: 'heading' as const,
            content: 'לוחות זמנים ופיצוי על איחור',
          },
          {
            type: 'paragraph' as const,
            content: 'חוזה טוב חייב להגדיר תאריך מסירה מדויק.',
          },
          {
            type: 'list' as const,
            content: [
              'שימו לב לסעיף "תקופת הגרייס" (לרוב 60 יום) שבהם הקבלן יכול לאחר מבלי לשלם פיצוי',
              'ודאו שהחוזה אינו כולל סעיפים המאפשרים לקבלן לדחות את המסירה ללא הגבלה בשל נסיבות "שאינן בשליטתו" באופן רחב מדי',
            ],
          },
          {
            type: 'heading' as const,
            content: 'רישום הבית המשותף',
          },
          {
            type: 'paragraph' as const,
            content:
              'רוכשים רבים שוכחים לבדוק תוך כמה זמן מתחייב הקבלן לרשום את הבניין כבית משותף ואת הדירה על שמם בטאבו. אי-רישום למשך שנים רבות עלול להקשות עליכם במכירת הדירה בעתיד או בקבלת משכנתא.',
          },
          {
            type: 'quote' as const,
            content:
              'חוזה לרכישת דירה מקבלן הוא חוזה אחיד ומוטה לטובת היזם ב-99% מהמקרים. ליווי משפטי על ידי עורך דין המתמחה במקרקעין הוא לא "הוצאה מיותרת", אלא השקעה שמגנה על הכסף והשקט הנפשי שלכם.',
          },
        ],
      },
      {
        slug: 'durable-power-of-attorney',
        title: 'ייפוי כוח מתמשך: המדריך המלא',
        date: '28-01-2026',
        author: 'עו"ד רון להב היימן',
        readTime: '6 דקות קריאה',
        excerpt:
          'עד לפני שנים בודדות, אם אדם איבד את יכולתו לקבל החלטות, הדרך היחידה לנהל את ענייניו הייתה באמצעות מינוי אפוטרופוס. היום, החוק מאפשר לכם לקבוע מראש מי יטפל בכם.',
        heroImage: '/images/articles/article-4.webp',
        body: [
          {
            type: 'paragraph' as const,
            content:
              'עד לפני שנים בודדות, אם אדם איבד את יכולתו לקבל החלטות (בשל דמנציה, תאונה או מחלה), הדרך היחידה לנהל את ענייניו הייתה באמצעות מינוי אפוטרופוס על ידי בית המשפט. מדובר בתהליך בירוקרטי, לעיתים מסורבל, שבו המדינה היא זו שמחליטה מי יטפל בכם.',
          },
          {
            type: 'paragraph' as const,
            content:
              'מהפכת יפוי הכוח המתמשך שינתה את התמונה. היום, החוק מאפשר לכם לקבוע מראש — בעודכם צלולים ובריאים — מי יטפל בכם, איך ייראו חייכם ואילו החלטות יתקבלו עבורכם ביום פקודה.',
          },
          {
            type: 'heading' as const,
            content: 'למה יפוי כוח מתמשך הוא מסמך חובה לכל אדם?',
          },
          {
            type: 'list' as const,
            content: [
              'החופש לבחור: אתם קובעים מי יהיה "מיופה הכוח" (בן זוג, ילד, חבר קרוב) ולא שופט שלא מכיר אתכם',
              'מניעת סכסוכים משפחתיים: הנחיות ברורות מראש מונעות "מלחמות ירושה" בעודכם בחיים ומסירות את נטל האשמה וההתלבטות מהקרובים אליכם',
              'שמירה על כבוד האדם: אתם יכולים להשאיר "הנחיות מקדימות" — החל מאיפה תרצו לגור ועד לאופן ניהול נכסי הנדל"ן והכספים שלכם',
              'דינמיות וגמישות: ניתן לעדכן או לבטל את המסמך בכל עת, כל עוד אתם בעלי כשירות משפטית',
            ],
          },
          {
            type: 'heading' as const,
            content: 'מה ניתן לכלול ביפוי הכוח?',
          },
          {
            type: 'paragraph' as const,
            content: 'יפוי הכוח המתמשך מתחלק בדרך כלל לשלושה תחומים מרכזיים:',
          },
          {
            type: 'list' as const,
            content: [
              'עניינים רכושיים: ניהול חשבונות בנק, נכסים, תשלומים והשקעות',
              'עניינים אישיים: רווחה, מגורים (בבית או בדיור מוגן), איכות חיים וצרכים יומיומיים',
              'עניינים רפואיים: הסכמה או סירוב לטיפולים רפואיים (בכפוף למגבלות החוק)',
            ],
          },
          {
            type: 'heading' as const,
            content: 'איך נראה התהליך? (שלב אחר שלב)',
          },
          {
            type: 'paragraph' as const,
            content:
              'תהליך עריכת יפוי הכוח הוא אישי ומעמיק, והוא חייב להתבצע מול עורך דין שעבר הכשרה מיוחדת והוסמך לכך על ידי האפוטרופוס הכללי.',
          },
          {
            type: 'list' as const,
            content: [
              'פגישת ייעוץ והבנת רצונות: עורך הדין מוודא שהממנה מבין את משמעות המסמך ומגבש איתו את רשימת מיופיי הכוח וההנחיות',
              'חתימה על המסמך: הממנה ומיופיי הכוח חותמים על הטפסים הדיגיטליים',
              'הפקדה אצל האפוטרופוס הכללי: המערכת הממשלתית מאשרת את ההפקדה. ללא הפקדה, למסמך אין תוקף',
              'כניסה לתוקף: יפוי הכוח "נכנס למגירה" ומופעל רק כאשר הממנה חדל להבין בדבר (לרוב על פי חוות דעת רפואית)',
            ],
          },
          {
            type: 'heading' as const,
            content: 'למה חשוב לעשות זאת דווקא עכשיו?',
          },
          {
            type: 'paragraph' as const,
            content:
              'הטעות הנפוצה ביותר היא לחכות ל"רגע המתאים". הבעיה היא שיפוי כוח מתמשך ניתן לערוך רק כשאתם כשירים משפטית. ברגע שחלה ירידה קוגניטיבית משמעותית, חלון ההזדמנויות נסגר, והמשפחה נאלצת לפנות למסלול האפוטרופסות היקר והמורכב.',
          },
          {
            type: 'quote' as const,
            content: 'יפוי כוח מתמשך הוא לא רק מסמך משפטי, הוא מתנה של ודאות שאתם מעניקים לעצמכם וליקירכם.',
          },
          {
            type: 'paragraph' as const,
            content:
              'משרדנו מוסמך על ידי משרד המשפטים לעריכת יפוי כוח מתמשך. אנו מזמינים אתכם לשיחת ייעוץ רגישה ומקצועית כדי להבטיח את עתידכם.',
          },
        ],
      },
      {
        slug: 'sale-law-foundations',
        title: 'חוק המכר (דירות): אבני היסוד שכל רוכש חייב להכיר',
        date: '15-01-2026',
        author: 'עו"ד אור יורוביץ',
        readTime: '7 דקות קריאה',
        excerpt:
          'רכישת דירה "על הנייר" טומנת בחובה חוסר איזון מובנה: מצד אחד עומד קבלן עם עוצמה כלכלית ומשפטית, ומהצד השני עומד הרוכש הפרטי. כדי לגשר על הפער, חוקק חוק המכר (דירות).',
        heroImage: '/images/articles/article-5.webp',
        body: [
          {
            type: 'paragraph' as const,
            content:
              'רכישת דירה "על הנייר" טומנת בחובה חוסר איזון מובנה: מצד אחד עומד קבלן עם עוצמה כלכלית ומשפטית, ומהצד השני עומד הרוכש הפרטי שמשקיע את כל הונו בנכס שטרם נבנה. כדי לגשר על הפער הזה, חוקק חוק המכר (דירות), תשל"ג-1973.',
          },
          {
            type: 'paragraph' as const,
            content:
              'חוק זה הוא "חוק קוגנטי" — כלומר, הקבלן אינו יכול להתנות עליו או לבטלו בחוזה, גם אם חתמתם על כך. להלן אבני היסוד שיגנו עליכם לאורך הדרך:',
          },
          {
            type: 'heading' as const,
            content: 'הבטחת כספי הרוכשים (ליווי בנקאי)',
          },
          {
            type: 'paragraph' as const,
            content:
              'זוהי אבן היסוד הקריטית ביותר. החוק אוסר על קבלן לקבל מהקונה סכום העולה על 7% ממחיר הדירה, אלא אם הבטיח את הכספים באחת מהדרכים הקבועות בחוק.',
          },
          {
            type: 'list' as const,
            content: [
              'ערבות בנקאית: הדרך הנפוצה ביותר. הבנק המלווה מנפיק לכם ערבות על כל שקל ששילמתם. אם הקבלן פושט רגל או לא מוסר את הדירה, הכסף שלכם מוגן',
              'חשוב לדעת: התשלום חייב להתבצע אך ורק באמצעות פנקס שוברים לחשבון הליווי של הפרויקט',
            ],
          },
          {
            type: 'heading' as const,
            content: 'המפרט הטכני — "מה שרואים זה מה שקונים"',
          },
          {
            type: 'paragraph' as const,
            content:
              'החוק מחייב את הקבלן לצרף לחוזה המכר מפרט (לפי פורמט קבוע של משרד השיכון). המפרט מתאר במדויק מה תקבלו בדירה: מסוג הריצוף ועד מספר השקעים.',
          },
          {
            type: 'paragraph' as const,
            content:
              'אם הקבלן לא צירף מפרט, או שהמפרט אינו ברור, החוק קובע כי הקבלן מחויב לספק מוצרים באיכות גבוהה וסטנדרט מקובל.',
          },
          {
            type: 'heading' as const,
            content: 'תקופת הבדק ותקופת האחריות',
          },
          {
            type: 'paragraph' as const,
            content: 'רוכשים רבים מתבלבלים בין המושגים, אך החוק מבחין ביניהם בצורה ברורה:',
          },
          {
            type: 'list' as const,
            content: [
              'תקופת הבדק: נמשכת בין שנה ל-7 שנים מרגע המסירה (תלוי בסוג הליקוי). בתקופה זו, חובת ההוכחה היא על הקבלן — עליו להוכיח שהליקוי נגרם באשמתכם, אחרת עליו לתקנו',
              'תקופת האחריות: נמשכת 3 שנים מתום תקופת הבדק. בתקופה זו, חובת ההוכחה עוברת לרוכש — עליו להוכיח שהליקוי נובע מתכנון או ביצוע לקוי של הקבלן',
            ],
          },
          {
            type: 'heading' as const,
            content: 'פיצוי בגין איחור במסירה',
          },
          {
            type: 'paragraph' as const,
            content: 'החוק קובע "תקופת חסד" (גרייס) של 60 יום מהמועד החוזי. אם הקבלן איחר ביותר מ-60 יום:',
          },
          {
            type: 'list' as const,
            content: [
              'הוא מחויב לשלם לכם פיצוי רטרואקטיבי מהיום הראשון לאיחור',
              'גובה הפיצוי: 150% מדמי שכירות של דירה דומה באזור (עבור 8 החודשים הראשונים) ו-125% לאחר מכן',
              'תיקון שנכנס לאחרונה לחוק מצמצם מאוד את היכולת של קבלנים לטעון ל"כוח עליון" כדי להתחמק מתשלום',
            ],
          },
          {
            type: 'heading' as const,
            content: 'הגבלת ההצמדה למדד',
          },
          {
            type: 'paragraph' as const,
            content: 'בעקבות תיקון 9 לחוק המכר (מיוני 2022), חלו שינויים דרמטיים לטובת הרוכשים:',
          },
          {
            type: 'list' as const,
            content: [
              'הקבלן רשאי להצמיד למדד תשומות הבנייה רק 40% ממחיר הדירה (רכיב הבנייה), ולא את מחיר הקרקע או המע"מ',
              'לאחר מועד המסירה שנקבע בחוזה, לא ניתן להמשיך להצמיד את המחיר למדד, גם אם חל איחור במסירה',
            ],
          },
          {
            type: 'paragraph' as const,
            content:
              'חוק המכר הוא מגן עוצמתי, אך הוא אינו פועל מאליו. כדי לוודא שהקבלן אכן עומד בחובותיו, ושכל הערבויות והנספחים תקינים מבחינה משפטית, ליווי של עורך דין מקרקעין הוא הכרחי משלב המו"מ ועד לקבלת המפתח.',
          },
        ],
      },
      {
        slug: 'construction-defects',
        title: 'ליקויי בנייה: מי אחראי, לכמה זמן, ואיך מתמודדים?',
        date: '20-12-2025',
        author: 'עו"ד ורו"ח עומר זילבר',
        readTime: '7 דקות קריאה',
        excerpt:
          'קיבלתם מפתח לדירה החדשה וגיליתם רטיבות, סדקים או ריצוף עקום? הכירו את הזכויות שלכם מול הקבלן ומה חוק המכר אומר על אחריות לליקויי בנייה.',
        heroImage: '/images/articles/article-6.webp',
        body: [
          {
            type: 'paragraph' as const,
            content:
              'עבור רובנו, הדירה היא הנכס היקר ביותר שנקנה אי פעם. הרגע שבו אנו מקבלים את המפתח הוא רגע של אושר, אך לעיתים קרובות הוא מלווה בגילויים פחות נעימים: ליקויי בנייה. חשוב לדעת כי החוק בישראל מטיל על הקבלן אחריות רחבה ומקיפה לטיב הבנייה, גם שנים לאחר שהדיירים נכנסו לדירה.',
          },
          {
            type: 'heading' as const,
            content: 'מה נחשב לליקוי בנייה?',
          },
          {
            type: 'paragraph' as const,
            content:
              'ליקוי בנייה הוא כל אי-התאמה בין המצב הקיים בדירה לבין המפרט הטכני, תקני הבנייה (תקן ישראלי) או תקנות התכנון והבנייה. הליקויים נחלקים לשלושה סוגים עיקריים:',
          },
          {
            type: 'list' as const,
            content: [
              'ליקויים גלויים: כאלו שניתן לראות בעין במועד המסירה (שריטות, ריצוף שבור, אביזרים חסרים)',
              'ליקויים נסתרים: ליקויים שמתגלים רק לאחר תקופת מגורים (נזילות המופיעות בחורף, בעיות איטום, סדקים בקירות)',
              'ליקויי בטיחות ויציבות: ליקויים חמורים שעלולים לסכן את חיי הדיירים',
            ],
          },
          {
            type: 'heading' as const,
            content: '"לוח הזמנים" של האחריות: תקופת הבדק מול תקופת האחריות',
          },
          {
            type: 'paragraph' as const,
            content: 'החוק מגדיר שתי תקופות זמן קריטיות שבהן הקבלן נושא באחריות:',
          },
          {
            type: 'heading' as const,
            content: 'תקופת הבדק (שנה עד 7 שנים)',
          },
          {
            type: 'paragraph' as const,
            content:
              'זוהי התקופה המשמעותית ביותר. היא מתחילה עם מסירת הדירה, ואורכה משתנה בהתאם לסוג הליקוי (למשל: שנה לליקויי צבע, 3 שנים לליקויי צנרת, 7 שנים לליקויי בידוד תרמי).',
          },
          {
            type: 'paragraph' as const,
            content:
              'המשמעות המשפטית: בתקופה זו, "נטל ההוכחה" הוא על הקבלן. עליו להוכיח שהליקוי נגרם בגלל שימוש לא סביר של הדייר. אם לא הוכיח זאת — עליו לתקן.',
          },
          {
            type: 'heading' as const,
            content: 'תקופת האחריות (3 שנים מתום תקופת הבדק)',
          },
          {
            type: 'paragraph' as const,
            content: 'תקופה זו מתחילה מיד עם סיום תקופת הבדק של הליקוי הספציפי.',
          },
          {
            type: 'paragraph' as const,
            content:
              'המשמעות המשפטית: בתקופה זו, "נטל ההוכחה" עובר לדייר. עליו להוכיח שהליקוי נובע מעבודה גרועה, תכנון לקוי או חומרים באיכות נמוכה של הקבלן.',
          },
          {
            type: 'heading' as const,
            content: 'אי התאמה יסודית (20 שנה ומעלה)',
          },
          {
            type: 'paragraph' as const,
            content:
              'במקרים של כשל במבנה או בשלד, האחריות של הקבלן יכולה להימתח לאורך עשרות שנים, שכן מדובר בבטיחות המבנה עצמו.',
          },
          {
            type: 'heading' as const,
            content: 'איך כדאי לפעול כשהתגלה ליקוי?',
          },
          {
            type: 'list' as const,
            content: [
              'תיעוד בזמן אמת: צלמו כל ליקוי מרגע הופעתו',
              'פנייה בכתב לקבלן: חובה לתת לקבלן "הזדמנות נאותה" לתיקון הליקוי (כדרישת החוק). פנו תמיד בכתב כדי לתעד את הפנייה',
              'חוות דעת הנדסית (בדק בית): מומלץ לשכור מהנדס מומחה שיערוך דוח ליקויים מפורט. דוח זה יהווה את הבסיס המקצועי לתביעה עתידית או לדרישת תיקון',
              'ייעוץ משפטי: אם הקבלן מתעלם, מבצע תיקונים קוסמטיים בלבד ("תיקוני טלאי") או מתנער מאחריות — זה הזמן לערב עורך דין',
            ],
          },
          {
            type: 'quote' as const,
            content: 'איחור בדיווח על ליקוי עלול לפגוע בזכותכם לפיצוי או לתיקון. אל תחכו שהנזק יחמיר.',
          },
          {
            type: 'paragraph' as const,
            content:
              'משרדנו מלווה דיירים ונציגויות בתים משותפים בתביעות ליקויי בנייה מורכבות, ופועל מול הקבלנים להשגת תיקון מלא או פיצוי כספי הולם.',
          },
        ],
      },
    ],
  },
  notFound: {
    pageTitle: '404',
    heading: 'הדף לא נמצא',
    message: 'מצטערים, העמוד שחיפשתם אינו קיים או שהועבר.',
    backHome: 'חזרה לעמוד הבית',
  },
  contact: {
    pageTitle: 'צור קשר',
    subtitle: 'נשמח לעמוד לשירותכם.\n מלאו את הטופס ונחזור אליכם בהקדם.',
    description:
      'אם יש לכם שאלות בנוגע לשירותים שלנו או שאתם זקוקים לעזרה, אנא מלאו את הטופס כאן. אנו עושים כמיטב יכולתנו להגיב תוך יום עסקים אחד.',
    form: {
      name: 'שם מלא',
      phone: 'טלפון',
      email: 'דוא"ל',
      service: 'תחום השירות',
      notes: 'תוכן הפנייה (אופציונלי)',
      submit: 'שלח',
      submitting: 'שולח...',
      successMessage: 'הטופס נשלח בהצלחה! נחזור אליכם בהקדם.',
      errorMessage: 'שגיאה בשליחת הטופס. נסו שוב.',
      successTitle: 'תודה רבה!',
      successSubtitle: 'פנייתך התקבלה בהצלחה',
      successBody: 'אחד מאנשי הצוות שלנו יחזור אליך בהקדם האפשרי.',
      successCta: 'חזרה לטופס',
      errorTitle: 'שגיאה בשליחה',
      retry: 'נסה שוב',
      serviceOptions: [
        { value: 'מקרקעין', label: 'מקרקעין' },
        { value: 'משפט מסחרי', label: 'משפט מסחרי' },
        { value: 'צוואות וייפויי כוח', label: 'צוואות וייפויי כוח' },
        { value: 'עסקאות מורכבות', label: 'עסקאות מורכבות' },
        { value: 'שמאות', label: 'שמאות' },
        { value: 'אחר', label: 'אחר' },
      ],
      validation: {
        nameRequired: 'שדה חובה',
        phoneRequired: 'שדה חובה',
        phoneInvalid: 'מספר טלפון לא תקין',
        emailInvalid: 'כתובת דוא"ל לא תקינה',
        notesMax: 'עד 500 תווים',
        serviceRequired: 'יש לבחור תחום שירות',
      },
    },
    info: {
      title: 'פרטי התקשרות',
      addressLabel: 'כתובת',
      phoneLabel: 'טלפון',
      whatsappLabel: 'WhatsApp',
      emailLabel: 'דוא"ל',
      hoursLabel: 'שעות פעילות',
    },
  },
} as const;
